import Lightbox from "../../../Presentation/Molecule/Lightbox/Lightbox";
import Alpine from 'alpinejs'

Alpine.data('cartOrderModal', () => ({
    init () {
        this.items = JSON.parse(localStorage.getItem('__cart') || '[]')
    },
    items: [],
    isSubmitting: false,

    get subtotal () {
        return this.items.reduce((carry, item) => {
            return carry + (item.quantity * parseFloat(item.price))
        }, 0);
    },

    get shipment () {
        return this.subtotal < 30 ? 2.7 : 0
    },

    get total () {
        return this.subtotal + this.shipment;
    },

    asEur (value) {
        const eurFormat = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
        });
        return eurFormat.format(value)
    },

    get canSubmit() {
        if (this.items.length === 0) {
            return false;
        }
        return true;
    },

    get itemsAsJson () {
        return JSON.stringify(this.items)
    }
}))

export class CartOrderModal {
    static init = () => {
        window.triggerResetCartEvent = this.triggerResetCartEvent
        window.triggerCloseCartOrderModalEvent = this.triggerCloseCartOrderModalEvent

        window.addEventListener('message',  (event) => {
            if (event.data === 'closeCartOrderModal') {
                this.close()
            }
        })
    }

    static getElement = () => {
        return document.getElementById('cart-order-modal')
    }

    static open = () => {
        Lightbox.openLightbox(this.getElement())
    }

    static close = () => {
        Lightbox.closeLightbox(this.getElement())
    }

    static reloadIframeAndOpen = () => {
        const modal = this.getElement()
        if (!modal) {
            return;
        }

        const iframe = modal.querySelector('iframe')

        if (iframe) {
            const onIframeLoad = () => {
                Lightbox.openLightbox(modal)
                iframe.removeEventListener('click', onIframeLoad)
            }
            iframe.addEventListener("load", onIframeLoad);
            iframe.contentWindow.location.href = document.body.dataset.checkoutUri;
        }
    }

    static triggerResetCartEvent = () => {
        window.parent.postMessage('resetCart', '*')
    }

    static triggerCloseCartOrderModalEvent = () => {
        window.parent.postMessage('closeCartOrderModal', '*')
    }
}
